var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcOnboardingPreferences(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CC_onboarding_preferences") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0911470168 0.81404359 41.5600543 0.81404359 41.5600543 42.1245564 0.0911470168 42.1245564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.800451795,2.48405823 L0.71648832,39.9854176 L39.0234244,40.0491026 L39.1073879,2.55684107 C39.1073879,1.55243785 38.2714848,0.737270022 37.2405999,0.737270022 L37.2405999,0.737270022 L2.6663068,0.664487179 C1.63635484,0.664487179 0.800451795,1.47874522 0.800451795,2.48405823",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDAS/cta/desktop/in-tile/default",
    transform: "translate(-24.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC_onboarding_preferences",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC_onboarding_preferences-small",
    transform: "translate(0.853333, 0.853333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "translate(17.920000, 20.480000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.380727713,41.8026217 L0.474020463,3.61365309 C0.474020463,2.07716082 1.7269421,0.833510256 3.27280296,0.833510256 L38.9759384,0.878919256 C40.5217993,0.878919256 41.7747209,2.12442324 41.7747209,3.65906209 L41.6814281,41.8591513",
    id: "Fill-1",
    fill: "#FFCD41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(2.798783, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4664816,41.8396846 L41.5607169,3.30495247 C41.564439,1.96562422 40.4785114,0.875386868 39.1341629,0.869810206 L39.1248336,0.869810206 L2.65669764,0.81404359 C1.30768448,0.81404359 0.212427592,1.90428095 0.212427592,3.24918585 L0.0911470168,41.783918",
    id: "Fill-3",
    fill: "#FFCD41",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.7546679,41.9208974 L42.8386314,4.42863594 C42.8386314,3.42423272 42.0027284,2.60906489 40.9727764,2.60906489 L6.39755033,2.53628205 C5.36759837,2.53628205 4.53169533,3.3505401 4.53169533,4.3558531 L4.44773186,41.8572124",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FFE6A0",
    points: "38.0353609 18.4766744 12.4078425 18.4457897 12.4106412 16.3493795 38.0381597 16.3802641"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#FFE6A0",
    points: "38.8015742 34.7169282 17.9422483 34.691659 17.9441141 32.5952487 38.804373 32.6214538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#FFDC78",
    points: "42.8932077 9.24292308 4.57787524 9.18864103 4.58720452 2.18812821 42.9025369 2.24241026"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-top",
    transform: "translate(3.731710, 1.871795)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "checkmarks",
    transform: "translate(9.386667, 9.386667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9630819,31.6333333 C23.9943848,31.6333333 27.2627995,34.9193067 27.2627995,38.9722667 C27.2627995,43.0252267 23.9943848,46.3112 19.9630819,46.3112 C15.9308108,46.3112 12.6633643,43.0252267 12.6633643,38.9722667 C12.6633643,34.9193067 15.9308108,31.6333333 19.9630819,31.6333333",
    id: "Fill-32",
    fill: "#8CA579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0720129,41.4446307 C18.9316337,41.445604 18.7970633,41.384284 18.7041226,41.279164 L16.767858,39.039524 C16.5887535,38.8331773 16.6110206,38.519764 16.8162646,38.3396973 C17.0224768,38.1596307 17.3342154,38.181044 17.5133199,38.3873907 L19.0623316,40.178324 L22.5088826,35.7885907 C22.6899234,35.5841907 23.001662,35.564724 23.2059379,35.7467373 C23.3927874,35.9141507 23.4276402,36.195444 23.2833885,36.4017907 L19.4689472,41.2684573 C19.3769746,41.384284 19.2385317,41.4524173 19.0913756,41.454364 L19.0720129,41.4446307 Z",
    id: "Fill-34",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7696652,-6.21488046e-14 C19.8225091,-6.21488046e-14 25.5393304,5.74753333 25.5393304,12.8382667 C25.5393304,19.929 19.8225091,25.6765333 12.7696652,25.6765333 C5.7168213,25.6765333 -9.39811192e-14,19.929 -9.39811192e-14,12.8382667 C-9.39811192e-14,5.74753333 5.7168213,-6.21488046e-14 12.7696652,-6.21488046e-14",
    id: "Fill-38",
    fill: "#8CA579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2593788,17.1597693 C11.0115369,17.1607427 10.7753126,17.0546493 10.6107301,16.8677693 L7.21258572,12.974436 C6.86405809,12.6483693 6.84566357,12.0994093 7.1699879,11.7499827 C7.49528035,11.400556 8.04033885,11.3810893 8.38886648,11.707156 C8.42952804,11.7460893 8.4672852,11.788916 8.50020169,11.835636 L11.2206535,14.9697693 L17.2521178,7.29016933 C17.5493344,6.91738267 18.0905204,6.85606267 18.4622832,7.15390267 C18.8311416,7.44784933 18.8931021,7.98610267 18.6007261,8.35694267 C18.599758,8.35888933 18.5987898,8.35888933 18.5978217,8.360836 L11.9273901,16.8570627 C11.7705526,17.0585427 11.5323921,17.176316 11.2787414,17.179236 L11.2593788,17.1597693 Z",
    id: "Fill-52",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "details",
    stroke: "#FFCD41",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 46.8608417,
    y1: 7.57233867,
    x2: 46.8608417,
    y2: 12.9743387,
    id: "Stroke-40",
    strokeWidth: 1.70666667,
    strokeDasharray: "14.15680013020833,3.5433642578125"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.55254,
    y1: 10.268472,
    x2: 44.1687562,
    y2: 10.268472,
    id: "Stroke-42",
    strokeWidth: 1.70666667,
    strokeDasharray: "14.15680013020833,3.5433642578125"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.23115235,
    y1: 5.625672,
    x2: 5.23115235,
    y2: 11.027672,
    id: "Stroke-44",
    strokeWidth: 1.70666667,
    strokeDasharray: "14.15680013020833,3.5433642578125"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.92236655,
    y1: 8.32180533,
    x2: 2.53955089,
    y2: 8.32180533,
    id: "Stroke-46",
    strokeWidth: 1.70666667,
    strokeDasharray: "14.15680013020833,3.5433642578125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7300979,49.5820867 C0.51823831,41.8109933 -2.87603357,27.90498 2.59778651,16.2648867",
    id: "Stroke-48",
    strokeWidth: 1.79104478,
    strokeDasharray: "9.681323242187501,4.32755126953125,0.9681323242187501,4.840661621093751,2.90439697265625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4157615,3.36773333 C23.1947046,-0.365 32.2806264,-0.133346667 39.8611024,3.99066667",
    id: "Stroke-50",
    strokeWidth: 1.79104478,
    strokeDasharray: "9.681323242187501,4.32755126953125,0.9681323242187501,4.840661621093751,2.90439697265625"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcOnboardingPreferences);
export default __webpack_public_path__ + "static/media/CC_onboarding_preferences.60d44d5fb06d8763081bd608d7f2a500.svg";
export { ForwardRef as ReactComponent };